export default {
  ourLetter: "Unser Brief",
  restaurantIsClosed: "Restaurant ist geschlossen",
  isANewProduct: "Ist ein neues Produkt",
  isVegetarian: "Ist Vegetarier",
  containsLupin: "Enthält Lupine",
  containsCelery: "Enthält Sellerie",
  containsPeanuts: "Enthält Erdnüsse",
  containsCrustacean: "Enthält Krebstiere",
  containsGluten: "Enthält Gluten",
  containsEgg: "Enthält Ei",
  containsMilk: "Enthält Milch",
  containsMustard: "Enthält Senf",
  containsFish: "Enthält Fisch",
  containsSesame: "Enthält Sesam",
  containsSoy: "Enthält Soja",
  containsSulfite: "Enthält Sulfit",
  vegetarian: "Vegetarier",
  allergens: "ALLERGENE:",
  lupins: "Lupinen",
  celery: "Sellerie",
  peanuts: "Erdnüsse",
  crustaceans: "Krebstiere",
  gluten: "Gluten",
  egg: "Ei",
  dairyProducts: "Milchprodukte",
  mustard: "Senf",
  fish: "Fische",
  sesame: "Sesam",
  soy: "Soja",
  sulfite: "Sulfit",
  findProduct: "Produkt finden"
};
